<template>
  <div>
    <div class="mb-3">
      <span class="text-disabled">Завізовано </span>
      <b>{{ trackerGeneralInfo.agreed }} з {{ trackerGeneralInfo.all }}</b>
      <span class="text-disabled"> Учасників</span>
    </div>
    <route-tracker-stage
      v-for="stage of sortStages(activeRoute.stages)"
      :key="stage.id"
      :stage="stage"
      class="mb-3"></route-tracker-stage>
  </div>
</template>

<script setup lang="ts">
import RouteTrackerStage from './RouteTrackerStage.vue'
import { useDocument } from '../../document'
import { sortStages } from '@/components/doc-type-routes/helpers'
import { computed } from 'vue'

defineOptions({
  name: 'RouteTracker',
})

const { activeRoute } = useDocument()

const trackerGeneralInfo = computed<{ all: number; agreed: number }>(() => {
  let all = 0
  let agreed = 0

  for (const stage of activeRoute.value.stages) {
    all += stage.participants.length
    agreed += stage.participants.filter(p => p.resultId).length
  }

  return { all, agreed }
})
</script>
